export var STREAM__WITH_PAGINATION__INITIALIZE = 'STREAM__WITH_PAGINATION__INITIALIZE';
export var STREAM__WITH_PAGINATION__GO_TO_PREV_PAGE = 'STREAM__WITH_PAGINATION__GO_TO_PREV_PAGE';
export var STREAM__WITH_PAGINATION__GO_TO_NEXT_PAGE = 'STREAM__WITH_PAGINATION__GO_TO_NEXT_PAGE';
export var STREAM__WITH_PAGINATION__FETCH = 'STREAM__WITH_PAGINATION__FETCH';
export var STREAM__WITH_PAGINATION__FETCH_SUCCESS = 'STREAM__WITH_PAGINATION__FETCH_SUCCESS';
export var STREAM__WITH_PAGINATION__FETCH_FAILURE = 'STREAM__WITH_PAGINATION__FETCH_FAILURE';
import { StreamType } from '../types';
export var initialize = function (_a) {
    var streamId = _a.streamId, groupId = _a.groupId, _b = _a.streamParams, streamParams = _b === void 0 ? {} : _b, itemsPerFetch = _a.itemsPerFetch, items = _a.items, _c = _a.page, page = _c === void 0 ? 0 : _c, hasMore = _a.hasMore, total = _a.total, entities = _a.entities;
    return ({
        type: STREAM__WITH_PAGINATION__INITIALIZE,
        streamId: streamId,
        groupId: groupId,
        streamParams: streamParams,
        streamType: StreamType.WITH_PAGINATION,
        itemsPerFetch: itemsPerFetch,
        items: items,
        page: page,
        hasMore: hasMore,
        total: total,
        entities: entities,
    });
};
export var goToPrevPage = function (streamId) { return ({
    type: STREAM__WITH_PAGINATION__GO_TO_PREV_PAGE,
    streamId: streamId,
}); };
export var goToNextPage = function (streamId) { return ({
    type: STREAM__WITH_PAGINATION__GO_TO_NEXT_PAGE,
    streamId: streamId,
}); };
export var fetch = function (streamId) { return ({
    type: STREAM__WITH_PAGINATION__FETCH,
    streamId: streamId,
}); };
export var fetchSuccess = function (_a) {
    var streamId = _a.streamId, items = _a.items, entities = _a.entities, hasMore = _a.hasMore, total = _a.total;
    return ({
        type: STREAM__WITH_PAGINATION__FETCH_SUCCESS,
        streamId: streamId,
        items: items,
        entities: entities,
        hasMore: hasMore,
        total: total,
    });
};
export * from '../base/actions';
//# sourceMappingURL=actions.js.map